module.exports = __webpack_public_path__ + "assets/img/65_316.57aa0a8f.jpg";